import GenericApi from './GenericApi';
import {CancelTokenSource} from "axios";
import ITown from "../interfaces/ITown";
import IAgence from "../interfaces/IAgence";
import {Location} from "../types/Location";

/**
 * TownAPIs class.
 */
export default class TownAPIs {

    public static async getLocations(query: { search: string }, source?: CancelTokenSource): Promise<Location[]> {
        GenericApi.cancelToken = source ? source.token : null;

        return GenericApi.get('locations', query);
    }

    public static async getInterkabAgencies(query: { search: string }, source?: CancelTokenSource): Promise<IAgence[]> {
        GenericApi.cancelToken = source ? source.token : null;

        return GenericApi.get('interkab-agencies', query);
    }

    public static async getTownByParams(query: { insee: string, townId: number, postalCode?: string | null }, source?: CancelTokenSource): Promise<ITown[]> {
        GenericApi.cancelToken = source ? source.token : null;

        return GenericApi.get(`town-by-params`, query);
    }

    public static async getTownsByPostalCode(query: { postalCode: string }, source?: CancelTokenSource): Promise<ITown[]> {
        GenericApi.cancelToken = source ? source.token : null;

        return GenericApi.get(`towns-by-postal-code`, query);
    }

    public static async getTownByDepCode(query: { code: string }, source?: CancelTokenSource): Promise<ITown[]> {
        GenericApi.cancelToken = source ? source.token : null;

        return GenericApi.get(`towns-by-dep-code`, query);
    }

    public static async getInterkabPartnersInMultipleTowns(query: { names: string[], postalCodes: string[] }, source?: CancelTokenSource): Promise<any> {
        GenericApi.cancelToken = source ? source.token : null;

        return GenericApi.get(`ika-partners-in-multiple-towns`, query);
    }

    public static async getInterkabPartnersLocationsInMultipleTown(query: { names: string[], postalCodes: string[] }, source?: CancelTokenSource): Promise<any> {
        GenericApi.cancelToken = source ? source.token : null;

        return GenericApi.get(`ika-partners-locations-in-multiple-towns`, query);
    }

    /**
     * Find Towns in radius by lat, lng & radius.
     *
     * @param query
     * @param source
     */
    public static async findTownsInRadius(query: { insee: string, lat: number, lng: number, radius?: number }, source?: CancelTokenSource): Promise<ITown[]> {
        GenericApi.cancelToken = source ? source.token : null;

        return GenericApi.get(`towns-in-radius`, query);
    }

    /**
     * Find Towns from catchment area by agency name
     *
     * @param query
     * @param source
     */
    public static async findCatchmentAreaByAgency(query: { idAgence: number }, source?: CancelTokenSource) {
        GenericApi.cancelToken = source ? source.token : null;

        return GenericApi.get(`catchment-area-by-agency`, query);
    }
};
